export default __webpack_public_path__ + "static/media/movie-episode-8.97411b53.jpg";